import { Fragment } from 'react';

import HideIcon from '@usas/ui-web/components/icons/HideIcon';
import ShowIcon from '@usas/ui-web/components/icons/ShowIcon';
import Checkbox from '@usas/ui-web/components/checkboxes/Checkbox';
import SGColumnHeader from '@usas/ui-web/components/grids/SGColumnHeader';

import useSortableGrid from '@usas/ui-web/utils/UseSortableGrid';
import SGConstants from '@usas/ui-web/utils/SGConstants';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const DetailTableRow = ({ role, onUpdateIsTransferSelected }) => (
  <tr>
    <td>{role.orgRoleName || ''}</td>
    <td>{role.registrationExpirationDate || ''}</td>
    <td>{role.isInGoodStandingExpirationDate || ''}</td>
    <td>{role.isTransferPending === true ? 'Yes' : 'No'}</td>
    <td>
      {role.isTransferPending === false &&
        <Checkbox
          name={`isTransferSelected${role.personOrgRoleDurationId}`}
          checked={role.isTransferSelected}
          onChange={() => { onUpdateIsTransferSelected(role.personOrgRoleDurationId) }} />
      }
    </td>
  </tr>
);

const DetailTable = ({ nonAthlete, onUpdateIsTransferSelected }) => (
  <table className={global.DetailTable}>
    <thead>
      <tr>
        <th>Member Type</th>
        <th>Registration Expiration Date</th>
        <th>Good Standing Expiration Date</th>
        <th>Transfer Pending</th>
        <th>Transfer</th>
      </tr>
    </thead>
    <tbody>
      {Array.isArray(nonAthlete.roles) && nonAthlete.roles.length > 0
        ? nonAthlete.roles.map((role, i) => <DetailTableRow role={role} key={i} onUpdateIsTransferSelected={onUpdateIsTransferSelected} />)
        : <tr><td colSpan='5'>No Roles</td></tr>
      }
    </tbody>
  </table>
);

const GridRow = ({ nonAthlete, expandedId, onEditNonAthlete, onUpdateIsSyncSelected, onUpdateIsTransferSelected, onExpandClicked }) => (
  <Fragment>
    <tr>
      <td><a onClick={() => onEditNonAthlete(nonAthlete.personId)}>{nonAthlete.preferredName ? nonAthlete.preferredName : nonAthlete.firstName || ''} {nonAthlete.lastName || ''}</a></td>
      <td>{nonAthlete.birthDate || ''}</td>
      <td>{nonAthlete.orgRoleName || ''}</td>
      <td>
        <Checkbox
          name={`isSyncSelected${nonAthlete.memberId}`}
          checked={nonAthlete.isSyncSelected}
          onChange={() => { onUpdateIsSyncSelected(nonAthlete.memberId) }} />
      </td>
      <td className='pull-right'>
        <button
          className={global.IconButtonMargin}
          type="button"
          onClick={(e) => onExpandClicked(e, nonAthlete.personId)}>
          {expandedId === nonAthlete.personId ? <HideIcon /> : <ShowIcon />}
        </button>
      </td>
    </tr>
    {nonAthlete.personId === expandedId &&
      <tr className={global.Expanded}>
        <td colSpan="5">
          <DetailTable nonAthlete={nonAthlete} onUpdateIsTransferSelected={onUpdateIsTransferSelected} />
        </td>
      </tr>
    }
  </Fragment>
);

const ClubNonAthleteRosterFormGridLarge = ({ formGridState, isLoading, expandedId, onEditNonAthlete, onUpdateIsSyncSelected, onUpdateIsTransferSelected, onExpandClicked }) => {
  const {
    sortableGridState,
    onColumnClicked
  } = useSortableGrid(formGridState);

  return (
    <table className={[global.UsasTable, 'visible-md visible-lg'].join(' ')}>
      <thead>
        <tr>
          <SGColumnHeader sortableGridState={sortableGridState} columnLabel={'Name'} columnField={'lastName'}
            sortType={SGConstants.SORT_TYPE_ALPHABETICAL} onColumnClicked={onColumnClicked} />
          <SGColumnHeader sortableGridState={sortableGridState} columnLabel={'Birth Date'} columnField={'birthDate'}
            sortType={SGConstants.SORT_TYPE_DATE} onColumnClicked={onColumnClicked} />
          <SGColumnHeader sortableGridState={sortableGridState} columnLabel={'Member Type(s)'} columnField={'orgRoleName'}
            sortType={SGConstants.SORT_TYPE_ALPHABETICAL} onColumnClicked={onColumnClicked} />
          <th>Sync</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {isLoading === true
          ? <tr><td colSpan="5">Loading...</td></tr>
          : Array.isArray(sortableGridState.sortedGridData) && sortableGridState.sortedGridData.length > 0
            ? sortableGridState.sortedGridData.map((nonAthlete, i) =>
              <GridRow key={i} nonAthlete={nonAthlete} expandedId={expandedId} onEditNonAthlete={onEditNonAthlete} onUpdateIsSyncSelected={onUpdateIsSyncSelected} onUpdateIsTransferSelected={onUpdateIsTransferSelected} onExpandClicked={onExpandClicked} />)
            : <tr><td colSpan="5">No Non Athletes</td></tr>
        }
      </tbody>
    </table>
  )
};

export default ClubNonAthleteRosterFormGridLarge;